var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"network-status"},[_c('v-icon',{staticClass:"mr-2",attrs:{"size":"20"}},[_vm._v("mdi-alert-outline")]),_c('span',[_vm._v("You are offline. Your data can’t be saved and may not be up to date.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }